import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faPlay,
  faPause,
  faLockOpen,
  faLock,
} from "@fortawesome/free-solid-svg-icons";
import { validateToken, callApi } from "../../../../../lib/utils";
import CustomModal from "../../../../GenericComponents/CustomModal";
import { Chart } from "react-google-charts";
import moment from "moment";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { unionBy } from "lodash";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector } from "react-redux";
import PulseLoader from "react-spinners/PulseLoader";
import AbnormalMotionEventGraph from "../../../../GenericComponents/EventSpecificGraph/AbnormalMotionEventGraph";
import EventClassification from "./constant";

const AMEventModal = ({ modalData, getEventClassification }) => {
  const [show, setShow] = useState(false);
  const [isClassifyEvent, setIsClassifyEvent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [eventData, setEventData] = useState({});
  const [audio, setAudio] = useState(new Audio(""));
  const [playing, setPlaying] = useState(false);
  const [isAudioFileDeleted, setIsAudioFileDeleted] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [isTestEvent, setIsTestEvent] = useState(false);
  const [isPrivateAudio, setIsPrivateAudio] = useState(false);
  const [showAccessibilityModal, setShowAccessibilityModal] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const profileData = useSelector((state) => state?.dashboard);
  const toggle = () => setPlaying(!playing);

  useEffect(() => {
    playing ? audio.play() : audio.pause();
  }, [playing]);

  useEffect(() => {
    audio.addEventListener("ended", () => setPlaying(false));
    return () => {
      audio.removeEventListener("ended", () => setPlaying(false));
    };
  }, []);

  useEffect(() => {
    // getEventClassification(
    //   eventData?.isTestEvent || isTestEvent
    //     ? "Test Event"
    //     : eventData?.isFalseAlarmEvent === null && isClassifyEvent === null
    //     ? "Event Not Classified"
    //     : !(eventData?.isFalseAlarmEvent !== null
    //         ? eventData?.isFalseAlarmEvent
    //         : isClassifyEvent)
    //     ? "An Actual Event"
    //     : "Not An Actual Event"
    // );
    let eventType = "";
    if (eventData?.eventClassifiedAs === "T") {
      eventType = EventClassification.T;
    } else if (eventData?.eventClassifiedAs === "F") {
      eventType = EventClassification.F;
    } else if (
      eventData?.eventClassifiedAs === null &&
      isClassifyEvent === null
    ) {
      eventType = EventClassification.null;
    } else if (
      (eventData?.eventClassifiedAs !== null &&
        eventData?.eventClassifiedAs === "A") ||
      (isClassifyEvent !== null && !isClassifyEvent)
    ) {
      eventType = EventClassification.A;
    } else if (
      (eventData?.eventClassifiedAs !== null &&
        eventData?.eventClassifiedAs === "N") ||
      isClassifyEvent
    ) {
      eventType = EventClassification.N;
    }

    getEventClassification(eventType);
  }, [isTestEvent, eventData, isClassifyEvent, getEventClassification]);

  const heartRateData = eventData?.sensorData?.processedHrData
    ? eventData?.sensorData?.processedHrData
    : [];

  let heartRate = heartRateData?.filter((item, index) => item.y !== 0);
  heartRate = heartRate.sort((a, b) => a.y - b.y);

  const graphData = [
    ...(eventData?.sensorData?.formattedData &&
    eventData?.sensorData?.formattedData?.length &&
    !!eventData?.sensorData?.formattedData
      ? eventData?.sensorData?.formattedData
      : heartRate?.length
      ? heartRate
      : []),
  ];

  const result = unionBy(heartRate, graphData, "x");

  const newData = result?.map((item, index) => {
    let temp = undefined;
    let sec = undefined;
    let isHeartRateValueExists = false;
    if (heartRate[index]?.y !== undefined) {
      temp = heartRate[index]?.y;
      sec = heartRate[index]?.x;
      isHeartRateValueExists = true;
    }
    if (sec === undefined) {
      sec = item.x;
    }
    if (temp === 0) {
      temp = undefined;
    }
    return !!heartRate?.length
      ? [sec, item?.y && !isHeartRateValueExists ? item?.y : 0, temp]
      : [sec, item?.y ? item?.y : 0];
  });

  const paramData = !!heartRate?.length
    ? ["Motion Monitoring", "Heart Rate"]
    : ["Motion Monitoring"];
  const data = newData?.length
    ? [
        [
          {
            type: "number",
            label: "Motion Monitoring Duration ( In Secs )",
            fill: false,
          },
          ...paramData,
        ],
        ...newData,
      ]
    : [];
  // const options = {
  //   title: "Abnormal Motion Amplitude",
  //   width: "100%",
  //   height: 500,
  //   legend: "bottom",
  //   series: !!heartRate?.length
  //     ? {
  //         0: { targetAxisIndex: 0, type: "line", axis: "AbnormalMotion" },
  //         1: { targetAxisIndex: 1, type: "scatter", axis: "HeartRate" },
  //       }
  //     : {
  //         0: { targetAxisIndex: 0, type: "line", axis: "AbnormalMotion" },
  //       },
  //   axes: {
  //     y: !!heartRate?.length
  //       ? {
  //           AbnormalMotion: { label: "Abnormal Motion" },
  //           HeartRate: { label: "Heart Rate" },
  //         }
  //       : { AbnormalMotion: { label: "Abnormal Motion" } },
  //   },
  //   vAxes: !!heartRate?.length
  //     ? {
  //         0: { title: "Abnormal Motion" },
  //         1: {
  //           title: "Heart Rate",
  //           format: "0",
  //           minValue: heartRate[0].y - 5,
  //           maxValue: heartRate[heartRate?.length - 1].y + 5,
  //         },
  //       }
  //     : { 0: { title: "Abnormal Motion" } },

  //   hAxis: {
  //     title: "Abnormal Motion Duration ( In Secs )",
  //   },
  //   colors: ["#5CB3FF", "#E42217"],
  // };
  const handleClassifyEvent = (isClassifyEventType) => {
    const id = modalData.referenceId;
    let params = {
      eventClassifiedAs: isClassifyEventType === true ? "N" : "A",
    };
    validateToken((err) => {
      if (err) {
        // console.log(err);
        window.location = "/logout";
      }
      callApi(`/api/event/abnormal-motion/false-alarm/${id}`, params, "PATCH")
        .then((response) => {
          //setIsClassifyEvent(null);
        })
        .catch((err) => {
          console.log("err: ", err);
          // this.setState({
          //   loading: false,
          //});
        });
    });
  };

  const handleDelete = (name, isConfirm) => {
    if (isConfirm) {
      setIsAudioFileDeleted(true);
    }
    if (isConfirm) {
      const id = modalData.referenceId;
      validateToken((err) => {
        if (err) {
          // console.log(err);
          window.location = "/logout";
        }
        callApi(`/api/event/abnormal-motion/audio/${id}`, {}, "DELETE")
          .then((response) => {})
          .catch((err) => {
            console.log("err: ", err);
          });
      });
    }
    setShow(!show);
  };

  const handleWarning = (name, isConfirm) => {
    if (isConfirm) {
      const id = modalData.referenceId;
      validateToken((err) => {
        if (err) {
          // console.log(err);
          window.location = "/logout";
        }
        callApi(`/api/event/abnormal-motion/mark/test-event/${id}`, {}, "PATCH")
          .then((response) => {
            setIsTestEvent(true);
          })
          .catch((err) => {
            console.log("err: ", err);
          });
      });
    } else {
      setIsClassifyEvent(true);
      handleClassifyEvent(true);
    }
    setShowWarningModal(!showWarningModal);
  };
  const handleAccessibility = (name, isConfirm) => {
    if (isConfirm) {
      const id = modalData.referenceId;
      let params = {
        accessibilityStatus: "PRI",
      };
      validateToken((err) => {
        if (err) {
          // console.log(err);
          window.location = "/logout";
        }
        callApi(
          `/api/event/abnormal-motion/audio/accessibility/${id}`,
          params,
          "PATCH"
        )
          .then((response) => {
            setIsPrivateAudio(true);
          })
          .catch((err) => {
            console.log("err: ", err);
          });
      });
    } else {
      setIsPrivateAudio(false);
    }
    setShowAccessibilityModal(!showAccessibilityModal);
  };
  useEffect(() => {
    validateToken((err) => {
      if (err) {
        // console.log(err);
        window.location = "/logout";
      }
      let params = {
        patient_id: modalData.patientId,
        event_type: modalData.eventType,
        event_id: modalData.referenceId,
      };
      setLoading(true);
      callApi(
        `/api/patient/events/${params.patient_id}/${params.event_type}/${params.event_id}`,
        {},
        "GET"
      )
        .then((response) => {
          setEventData(response?.data?.data?.abnormalMotionEvent);
          setLoading(false);
          setIsClassifyEvent(
            response?.data?.data?.abnormalMotionEvent?.isFalseAlarmEvent
          );
          setAudio(
            new Audio(
              response?.data?.data?.abnormalMotionEvent?.isAudioFileDeleted ===
              "N"
                ? `/upload/patient/web/abnormal-motion/audio/${modalData?.referenceId}`
                : ""
            )
          );
        })
        .catch((err) => {
          console.log("err: ", err);

          setLoading(false);
        });
    });
  }, []);

  const MyMapComponent = ({ center, zoom }) => {
    const ref = useRef();

    useEffect(() => {
      new window.google.maps.Map(ref.current, {
        center,
        zoom,
      });
    });

    return (
      <div ref={ref} id="map" style={{ height: "400px", width: "100%" }} />
    );
  };
  const mapStatus = (status) => {
    if (status === Status.FAILURE) return <div>Status: {Status.FAILURE}</div>;
    //return <Spinner />;
  };
  const minutes = Math.floor(audio?.duration / 60);
  const seconds = Math.floor(audio?.duration - minutes * 60);

  return (
    <>
      <Row className="patient-details-container heading-container">
        <Col md={12} style={{ display: "flex" }}>
          <span
            style={{
              margin: "0 4px 0 0",
              fontWeight: "500",
              textTransform: "capitalize",
            }}
          >
            {modalData?.taskTextPlaceHolders?.eventTime}
          </span>
          <span style={{ textTransform: "capitalize" }}>
            Event triggered on,
          </span>
          {modalData?.taskMetadata?.eventDateTime && (
            <span style={{ marginLeft: "16px" }}>
              {moment(
                modalData?.taskMetadata?.eventDateTime
                  ?.replace(" PM", "")
                  ?.replace(" AM", "")
              ).format("MM/DD/YYYY")}
            </span>
          )}
          <span style={{ marginLeft: "16px" }}>
            For
            <span style={{ marginLeft: "16px" }}>
              {!!eventData?.totalEventDuration &&
                Math.floor(eventData?.totalEventDuration / 60) !== 0 &&
                moment({
                  hour: 0,
                  minute: eventData.totalEventDuration / 60,
                  seconds: eventData.totalEventDuration % 60,
                  milliseconds: 0,
                }).format("mm")}
              {!!(Math.floor(eventData?.totalEventDuration / 60) !== 0) && (
                <> min </>
              )}
              {!!eventData?.totalEventDuration &&
                moment({
                  hour: 0,
                  minute: eventData.totalEventDuration / 60,
                  seconds: eventData.totalEventDuration % 60,
                  milliseconds: 0,
                }).format("ss")}{" "}
              secs
            </span>
          </span>
        </Col>
      </Row>
      <Row style={{ paddingTop: "16px" }}>
        <Col md={12} style={{ display: "flex" }}>
          <h6 id="severity">Motion Monitoring Amplitude :</h6>
          <span style={{ fontWeight: "normal", paddingLeft: "18px" }}>
            {eventData?.severityByAmplitude
              ? eventData?.severityByAmplitude
              : "-"}
          </span>
        </Col>
      </Row>
      <Row style={{ paddingTop: "8px", paddingBottom: "8px" }}>
        <Col md={12} style={{ display: "flex" }}>
          <h6 id="severity">Motion Monitoring Frequency :</h6>

          <span style={{ fontWeight: "normal", paddingLeft: "18px" }}>
            {eventData?.severityByFrequency
              ? eventData?.severityByFrequency
              : "-"}
          </span>
        </Col>
      </Row>
      {eventData?.isAudioFileDeleted === "N" &&
        !isAudioFileDeleted &&
        !!profileData?.appModules?.active?.ADORE?.length &&
        !profileData?.appModules?.inactive?.ADORE?.length && (
          <Row>
            <Col md={12} style={{ display: "flex" }}>
              <h6>
                {" "}
                Audio Recording:{" "}
                <span style={{ fontWeight: "normal" }}>Available</span>
              </h6>

              <div style={{ padding: "0 38px" }}>
                {!!audio?.duration && (
                  <span style={{ marginRight: "30px", color: "#5CB3FF" }}>
                    {!!audio?.duration && !isNaN(audio?.duration / 60) && (
                      <>
                        {Math.floor(audio?.duration / 60) !== 0 &&
                          Math.floor(audio?.duration / 60) + " min "}
                        {Math.floor(audio?.duration - minutes * 60) !== 0 &&
                          Math.floor(audio?.duration - minutes * 60) + " secs"}
                      </>
                    )}
                  </span>
                )}
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="button-tooltip-play">
                      Click To Play Audio Recording
                    </Tooltip>
                  }
                >
                  <Button
                    id="playAudio"
                    className="icon"
                    variant="outline-dark"
                    onClick={toggle}
                    tooltip={"Click To Play Audio Recording"}
                  >
                    <FontAwesomeIcon icon={playing ? faPause : faPlay} />
                  </Button>
                </OverlayTrigger>
                {/* <FontAwesomeIcon
                style={{ cursor: "pointer", marginLeft: "48px" }}
                icon={faTrash}
                onClick={() => {
                  setShow(true);
                  //handleDelete();
                }}
              /> */}
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="button-tooltip-lock">
                      Click To Mark Audio Recording As Private
                    </Tooltip>
                  }
                >
                  <span className="accesibility">
                    <FontAwesomeIcon
                      style={{ cursor: "pointer", marginLeft: "48px" }}
                      icon={isPrivateAudio ? faLock : faLockOpen}
                      onClick={() => setShowAccessibilityModal(true)}
                    />
                  </span>
                </OverlayTrigger>
              </div>
            </Col>
          </Row>
        )}
      <AbnormalMotionEventGraph
        heartRateData={heartRateData}
        eventData={eventData}
        loading={loading}
        data={data}
      />
      {!!eventData?.minHr && eventData?.maxHr && eventData.avgHr && (
        <Row className="heartRate-Container">
          <Col>
            <>
              <h6 id="heartRate">
                Heart Rate:{" "}
                <span
                  style={{
                    fontWeight: "normal",
                    paddingRight: "16px",
                    marginRight: "16px",
                    borderRight: "solid 1px #000",
                  }}
                >
                  {eventData.minHr} - {eventData.maxHr} bpm
                </span>
                AVG:
                <span style={{ fontWeight: "normal" }}>
                  {" "}
                  {eventData.avgHr} bpm
                </span>
              </h6>
            </>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          {!!profileData?.appModules?.active?.GPS?.length &&
            !profileData?.appModules?.inactive?.GPS?.length &&
            !!eventData?.latitude &&
            !!eventData?.longitude && (
              <>
                <Row>
                  <Col md={5}>
                    <h6 style={{ padding: "8px" }} id="location">
                      Location At Time of Trigger Motion Monitoring Event :
                    </h6>
                  </Col>
                  <Col md={7}>
                    <div style={{ padding: "8px 0 8px 0", lineHeight: "1.2" }}>
                      {eventData?.address}
                    </div>
                  </Col>
                  {/* <Col md={4} style={{ padding: "8px" }} >
                   {!showMap && (
                    <Button
                      variant="link"
                      onClick={() => setShowMap(true)}
                      to={<MyMapComponent />}
                    >
                      Click To View Location
                    </Button>
                  )} 
                  {eventData?.address}
                </Col> */}
                </Row>
              </>
            )}
          {!!eventData?.latitude &&
            !!eventData?.longitude &&
            // <GoogleMap
            //   iframe={`<iframe width="100%" height="350" frameborder="0" title="googleMap" id="eventLocation" marginheight="0" marginwidth="0"  src="https://www.google.com/maps/place/${eventData?.latitude}+${eventData?.longitude}/@${eventData?.latitude},${eventData?.longitude}" ref={refIframe}></iframe>`}
            // />

            showMap && (
              <Wrapper
                apiKey={"AIzaSyBZ-neHCssh_jPwQExqLW-KRfucDUaxIq8"}
                render={mapStatus}
              >
                <MyMapComponent
                  center={{
                    lat: eventData?.latitude,
                    lng: eventData?.longitude,
                  }}
                  zoom={4}
                />
              </Wrapper>
            )}
        </Col>
      </Row>
      {eventData?.eventClassifiedAs === null && isClassifyEvent === null ? (
        <Row>
          <Col
            xs="12"
            sm="6"
            md="6"
            lg="6"
            className="d-flex justify-content-md-end justify-content-xs-center"
          >
            <Button
              className="btn-Actual-event"
              style={{ marginTop: "50px", alignItems: "center" }}
              id="actualEvent"
              onClick={() => {
                // setIsClassifyEvent(true);
                // handleClassifyEvent(true);
                //setShow(true);
                setShowWarningModal(true);
              }}
            >
              CLASSIFY AS NOT AN ACTUAL EVENT
            </Button>
          </Col>
          <Col xs="12" sm="6" md="6" lg="6">
            <Button
              className="btn-not-Actual-event"
              style={{ marginTop: "50px" }}
              id="notActualEvent"
              onClick={() => {
                setIsClassifyEvent(false);
                handleClassifyEvent(false);
              }}
            >
              CLASSIFY AS AN ACTUAL EVENT
            </Button>
          </Col>
        </Row>
      ) : (
        <></>
        // <Row>
        //   <Col>
        //     <h6 style={{ marginTop: "16px" }}>
        //       Event Classification :{" "}
        //       {!(eventData?.isFalseAlarmEvent !== null?eventData?.isFalseAlarmEvent:isClassifyEvent)
        //         ? " An Actual Event"
        //         : "Not An Actual Event"}
        //     </h6>
        //   </Col>
        // </Row>
      )}
      <CustomModal
        title="Are you sure you want to delete Audio Recording?"
        header={"Confirm"}
        size="small"
        id="deleteModal"
        show={show}
        action={handleDelete}
      />
      <CustomModal
        title="You indicated this was not an Actual event. <br/>Was this a Test Event?"
        header={"Warning"}
        size="small"
        id="warningModal"
        show={showWarningModal}
        action={handleWarning}
        close={() => {
          setShowWarningModal(false);
        }}
        closeButton={true}
      />
      <CustomModal
        title="Are you sure you want to mark the audio file as private?"
        header={"Confirm"}
        size="small"
        id="accessibilityModal"
        show={showAccessibilityModal}
        action={handleAccessibility}
        close={() => {
          setShowAccessibilityModal(false);
        }}
      />
    </>
  );
};

export default AMEventModal;
